<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <path fill-rule="evenodd" d="M1 4.243a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v2.243a1 1 0 0 1-1 1H1Zm0 9.877a1 1 0 0 1-1-1v-2.243a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v2.243a1 1 0 0 1-1 1H1ZM0 23a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-2.243a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1V23Z"/>
</svg>
